import {Observable} from "rxjs/Observable";
import {_throw} from "rxjs/observable/throw";
import {delayWhen} from 'rxjs/operators';
import {timer} from "rxjs/observable/timer";
import {UserService} from "../../../core/_services/user.service";
import {VehicleDisplayPipe} from "../../_pipes/vehicle-display.pipe";
import {of} from 'rxjs/observable/of';
import 'rxjs/add/operator/filter';
import {Subscription} from "rxjs/Subscription";
import {Injectable, OnDestroy} from "@angular/core";
import {DataSource, OptionEntry} from '../search-select/types';

@Injectable()
export class VehicleDataSourceService implements DataSource, OnDestroy {
    private readonly component = "vehicle-data-source";

    vehicleSubscription: Subscription;
    vehicles: any = [];

    constructor(private userService: UserService) {

        this.vehicleSubscription = this.userService.getVehicles(this.component).subscribe((result) => {
            if (result.vehicles.length > 0) {
                let pipe = new VehicleDisplayPipe();
                this.vehicles = result.vehicles.map((vehicle: any) => {
                    vehicle.displayName = pipe.transform(vehicle, true);
                    return vehicle;
                });
            }
        });
    } // constructor()

    ngOnDestroy() {
        this.vehicleSubscription.unsubscribe();
    } // ngOnDestroy()

    displayValue(value: any): Observable<OptionEntry | null> {
        const id = Number(value);
        const vehicle = this.vehicles.find((possibleVehicle: any) => possibleVehicle.id === id);
        if (vehicle) {
            return of({
                value: vehicle,
                display: vehicle.displayName,
                details: {}
            });
        }
        return of(null);
    } // displayValue()

    search(term: string): Observable<OptionEntry[]> {
        if (term === 'error') {
            return _throw('testing');
        }
        const lowerTerm = typeof term === 'string' ? term.toLowerCase() : '';
        const result = this.vehicles
            .filter((vehicle: any) => vehicle.displayName.toLowerCase().indexOf(lowerTerm) !== -1)
            .slice(0, 30)
            .map((vehicle: any) => ({
                value: vehicle,
                display: vehicle.displayName,
                details: vehicle
            }));
        return of(result).pipe(
            delayWhen(_event => timer(Math.random() * 100 + 400)));
    } // search()

} // VehicleDataSourceService
